module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"limit":"Limit","advanceRate":"Advance rate","invoiceLength":"Invoice length (days)"},"et":{"limit":"Limit","advanceRate":"Advance rate","invoiceLength":"Invoice length (days)"},"ru":{"limit":"Limit","advanceRate":"Advance rate","invoiceLength":"Invoice length (days)"}}')
  delete Component.options._Ctor
}
